<template>
  <el-main>
    <component :is="chart"></component>
    <edit-chart :chart-name="chart"/>
  </el-main>
</template>

<script>
/*
  edit chart children component from analytics mixin
  for add new edit chart u need import chart-component here
*/

// components from Common
import PublicationsBySource from "../../analytics/components/tabs/components/common/components/PublicationsBySource";
import PublicationsBySourceAndGsm from "../../analytics/components/tabs/components/common/components/PublicationsBySourceAndGsm";
import DynamicBySource from "../../analytics/components/tabs/components/common/components/DynamicBySource";
import DynamicBySourceAndGsm from "../../analytics/components/tabs/components/common/components/DynamicBySourceAndGsm";
import TonalPost from "../../analytics/components/tabs/components/common/components/TonalPost";
import TonalComment from "../../analytics/components/tabs/components/common/components/TonalComment";

// native components
import EditChart from "./editChart/EditChart";

export default {
  name: "PageContent",
  computed: {
    chart() {
      return this.$route.params.chart;
    }
  },
  components: {
    PublicationsBySource,
    PublicationsBySourceAndGsm,
    DynamicBySource,
    DynamicBySourceAndGsm,
    EditChart,
    TonalPost,
    TonalComment,
  },
};
</script>
